import React, { useRef } from 'react';
import { useDispatch } from 'react-redux';
import { Page, BackButtonTitle } from 'src/components-dummy';
import { useAppSelector } from 'src/hooks';
import { SimilarByPatternSettings } from 'src/components-bl';
import { ShopRoutes } from '../../types/enums/shop-routes';
import './SimilarByPatternContainer.scss';

export const SimilarByPatternContainer = (): JSX.Element | null => {
  const formHeaderRef = useRef<HTMLDivElement>(null);

  const shopId = useAppSelector(state => state.shop.current?.shopId);
  const similarByPatternSettings = useAppSelector(state => state.similarByPatternSettings);
  const dispatch = useDispatch();
  const navigationPath = `/shops/${shopId}/${ShopRoutes.ShopperExperiences}`;

  return (
    <Page className='similar-by-pattern-container'>
      <Page.Header>
        <BackButtonTitle path={navigationPath}>Similar By Pattern</BackButtonTitle>
        <div className='similar-by-pattern-buttons-section' ref={formHeaderRef} />
      </Page.Header>
      <Page.Content>
        {shopId && (
          <SimilarByPatternSettings
            similarByPatternSettings={similarByPatternSettings}
            shopId={shopId}
            formHeaderElementRef={formHeaderRef}
            dispatch={dispatch}
          />
        )}
      </Page.Content>
    </Page>
  );
};
